import { useEffect, useState } from "react";
import FormField from "./FormField";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import Text from "./Text";
import { ProgressSpinner } from "primereact/progressspinner";
import { IVehicleModelYear, useFindVehicleModel } from "../hooks/useFindVehicleModel";

export interface IVehicleModelSearchSelectorProps {
    brandCode: string|undefined;
    selectedVehicleModel: { id: string; name: string; }|undefined;
    disabled: boolean;
    selectVehicleModel: (vehicleModel: { id: string; name: string; code: number; years: IVehicleModelYear[]; }|undefined) => void;
    hasError?: boolean;
    error?: string;
}

const VehicleModelSearchSelector = (props: IVehicleModelSearchSelectorProps) => {
    const { 
        findVehicleModelByBrandCodeAndName, 
        loadingVehicleModels,
        vehicleModelsSearch, 
        setVehicleModelsSearch
    } = useFindVehicleModel();
    const [vehicleModelSearchText, setVehicleModelSearchText] = useState("");

    useEffect(() => {
        if (!props.brandCode) {
            return;
        }

        const searchTimeout = setTimeout(async () => {
            await findVehicleModelByBrandCodeAndName(props.brandCode!, vehicleModelSearchText);
        }, 1000);

        return () => clearTimeout(searchTimeout);
    }, [vehicleModelSearchText]);


    return (
        <FormField
            id="vehicleModelSearchSelector"
            label="Procure pelo modelo"
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText 
                    value={props.selectedVehicleModel?.name ?? vehicleModelSearchText}
                    className="w-full pr-5"
                    disabled={props.disabled}
                    invalid={props.hasError}
                    onChange={(e) => {
                        setVehicleModelSearchText(e.target.value);
                    }}
                />
                
                {
                    !!props.selectedVehicleModel?.name && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.selectVehicleModel(undefined);
                            setVehicleModelsSearch([]);
                            setVehicleModelSearchText("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                loadingVehicleModels && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!vehicleModelsSearch?.length && !props.selectedVehicleModel?.name && vehicleModelSearchText && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            vehicleModelsSearch.map(v => {
                                return (
                                    <li key={v.id}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                props.selectVehicleModel({
                                                    id: v.id, 
                                                    name: v.name, 
                                                    code: v.value, 
                                                    years: v.years
                                                });
                                            }}
                                        >
                                            {v.name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default VehicleModelSearchSelector;
